<template>
  <div class="child-ratio-bar row">
    <!-- bar -->
    <div class="col-12 p-0 position-relative" v-on:click="showModalRatio = true">
      <div v-if="data !== null" style="height: 40px">
        <div
            v-bind:key="item.id"
            v-for="item in timeToBlocks(data.ratio)"
            :style="[item.css]"
        >
          <div v-if="item.status === 10" class="status status-success">
            {{ item.children }}
          </div>
          <div v-else-if="item.status === 20" class="status status-danger">
            {{ item.children }}
          </div>
          <div v-else-if="item.status === 30" class="status status-warning">
            {{ item.children }}
          </div>
          <div v-else>
            <!-- nothing -->
          </div>
        </div>
      </div>
    </div>
    <!-- modal -->
    <modal v-if="showModalRatio" id="planning-child-ratio">
      <template v-slot:header>
        <h3 class="modal-title">
          Kindleidster ratio
          <span v-if="date">
            {{ this.$moment(date).format('dddd D MMMM YYYY') }}
          </span>
        </h3>
      </template>
      <template v-slot:body>
        <div>
          <table class="table" style="margin-bottom: 0; text-align: center;">
            <thead>
            <tr class="active">
              <td width="25%">tijd</td>
              <td v-if="data.hasGroupChildrenColumn">kinderen op groep</td>
              <td>kinderen</td>
              <td>ped. mdw.</td>
              <td>nodig</td>
            </tr>
            </thead>
            <tbody style="color: white">
            <tr v-bind:key="item.id" v-for="item in data.ratio" :class="'status-' + item.status">
              <td style="padding-left: 20px;" width="25%">
                {{ item.start_time.substr(0, 5) }} - {{ item.end_time.substr(0, 5) }}
              </td>
              <td v-if="data.hasGroupChildrenColumn">
                {{ item.childrenGroup }}
              </td>
              <td>
                {{ item.children }}
              </td>
              <td>
                {{ item.employees }}
              </td>
              <td>
                {{ item.ratio }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </template>
      <template v-slot:footer>
        <div>
          <button type="button" class="btn btn-outline-info" v-on:click="showModalRatio = false">Annuleren</button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal'

export default {
  name: 'child-ratio-bar',
  components: {
    Modal
  },
  props: {
    date: {
      type: String,
      required: false
    },
    data: {
      type: Object,
      required: true
    },
    maxEndTime: {
      type: [String, null],
      required: false,
      default: null,
    },
    minStartTime: {
      type: [String, null],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      showModalRatio: false,
      startTime: null,
      endTime: null,
      hourPercentage: null,
    }
  },
  methods: {
    timeToBlocks(scheduleBlocks) {

      let i;
      let blocks = []

      let startTime = null
      let endTime = null
      for (i = 0; i < scheduleBlocks.length; i++) {
        if (startTime === null || scheduleBlocks[i].start_time < startTime) {
          startTime = scheduleBlocks[i].start_time
        }

        if (endTime === null || scheduleBlocks[i].end_time > endTime) {
          endTime = scheduleBlocks[i].end_time
        }
      }

      if (endTime === '00:00:00') {
        endTime = '23:59:59'
      }

      if (this.minStartTime !== null && startTime < this.minStartTime) {
        startTime = this.minStartTime
      }

      if (this.maxEndTime !== null && endTime > this.maxEndTime) {
        endTime = this.maxEndTime
      }

      const startTimeMoment = this.$moment('2022-01-01 ' + startTime).startOf('hour')
      this.startTime = startTimeMoment.format('HH:mm:ss')
      const m = this.$moment('2022-01-01 ' + endTime)

      if (m.minute()) {
        m.add(1, 'hours')
      }
      this.endTime = m.startOf('hour').format('HH:mm:ss')
      const startTimeInt = parseInt(this.startTime.substr(0,2))
      let endTimeInt = parseInt(this.endTime.substr(0,2))
      // fix for child care until 00:00, see ticket #57469
      if (endTimeInt === 0) {
        endTimeInt = 24
      }

      this.hourPercentage = 100 / (endTimeInt - startTimeInt)

      for (i = 0; i < scheduleBlocks.length; i++) {

        if (scheduleBlocks[i].end_time < startTime){
          continue;
        }

        if (scheduleBlocks[i].start_time < startTime) {
          scheduleBlocks[i].start_time = startTime
        }

        if (scheduleBlocks[i].end_time > endTime) {
          scheduleBlocks[i].end_time = endTime
        }

        if (scheduleBlocks[i].start_time == scheduleBlocks[i].end_time) {
          continue
        }

        const startTimeBlock = this.$moment('2022-01-01 ' + scheduleBlocks[i].start_time)
        const endTimeBlock = this.$moment('2022-01-01 ' + scheduleBlocks[i].end_time)
        blocks.push({
          color: true,
          startTime: scheduleBlocks[i].start_time.substr(0, 5),
          endTime: scheduleBlocks[i].end_time.substr(0, 5),
          status: scheduleBlocks[i].status || null,
          children: scheduleBlocks[i].children || 0,
          css: {
            padding: '1px',
            position: 'absolute',
            display: 'inline-block',
            marginLeft: (this.hourPercentage * startTimeBlock.diff(startTimeMoment, 'hours', true)) + '%',
            width: 'calc(' + (this.hourPercentage * endTimeBlock.diff(startTimeBlock, 'hours', true)) + '%)',
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
          }
        })
      }
      return blocks
    },
  }
}
</script>

<style scoped>
div .status {
  margin-top: 5px;
  margin-bottom: 5px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  color: white;
}

.status-10 {
    border-left: 5px solid rgb(72, 200, 141);
}
.status-success {
    background: rgb(72, 200, 141) !important;
}
.status-20 {
    border-left: 5px solid rgb(255, 89, 79);
}
.status-danger {
    background: rgb(255, 89, 79) !important;
}
.status-30 {
    border-left: 5px solid #EFBA1C;
}
.status-warning {
    background: #EFBA1C !important;
}
</style>
